import * as React from 'react';
import stateUi from '@state/ui';
import { NodeTypes } from '@src/interfaces/nodes';
import NoneSelectedMutators from '@src/editor/Elements/TopBar/NoneSelectedMutators';
import ElementMutators from '@src/editor/Elements/TopBar/ElementMutators';
import BoxMutators from '@src/editor/Elements/TopBar/BoxMutators';
import TextMutators from '@src/editor/Elements/TopBar/TextMutators';
import IconMutators from '@src/editor/Elements/TopBar/IconMutators';
const TopBar = () => {
    const selectedNode = stateUi.selectedNode;
    if (!selectedNode) {
        return React.createElement(NoneSelectedMutators, null);
    }
    if (selectedNode.type === NodeTypes.Element) {
        return React.createElement(ElementMutators, null);
    }
    if (selectedNode.type === NodeTypes.Box) {
        return React.createElement(BoxMutators, null);
    }
    if (selectedNode.type === NodeTypes.Text) {
        return React.createElement(TextMutators, null);
    }
    if (selectedNode.type === NodeTypes.Icon) {
        return React.createElement(IconMutators, null);
    }
    return null;
};
export default TopBar;
